module.exports = __webpack_public_path__ + "img/yuugi hoshiguma_sc1.329c1754.png";